"use client"

import ErrorPage403 from "../components/ErrorState/Error/ErrorPage403"

const Page = () => {
  return <ErrorPage403 />
}

export default Page
